import Vue from 'vue'
import pricing from '@/pricing'
import util from '@/util'

const setCurrentUser = (state, payload) => {
  // eslint-disable-next-line global-require
  state.currentUser = {
    rememberSettings: {},
    ...payload,
  }
  state.workingMode = util.getWorkingMode()
}

const setIsTokenValid = (state, payload) => {
  state.isTokenValid = payload
}

const setPlan = (state, payload) => {
  state.plan = pricing.getPlanByType(payload)
}

const setIsTrialPlan = (state, payload) => {
  state.isTrialPlan = payload
}

const updateCurrentUser = (state, payload) => {
  if (!state.currentUser || !state.currentUser.id) return
  state.currentUser = {
    ...state.currentUser,
    ...payload,
  }
}

const updateCurrentABTest = (state, payload) => {
  if (!state.currentUser || !state.currentUser.id) return
  Vue.set(state.currentUser, 'abTest', {
    ...state.currentUser.abTest,
    ...payload,
  })
}

const setLimitationPresentation = (state, payload) => {
  state.planBenefitLimitation = {
    ...state.planBenefitLimitation,
    ...payload,
  }
}
const setUserSetting = (state, payload) => {
  state.currentUser.userSetting = {
    ...state.currentUser.userSetting,
    ...payload,
  }
}
export default {
  setCurrentUser,
  setIsTokenValid,
  setPlan,
  updateCurrentUser,
  updateCurrentABTest,
  setIsTrialPlan,
  setLimitationPresentation,
  setUserSetting,
}
